import React, { useEffect, useState } from 'react';

export default function QuestionView({ question, onAnswer }) {
  const [answered, setAnswered] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [showAnswers, setShowAnswers] = useState(false);
  const [transitioning, setTransitioning] = useState(false);

  useEffect(() => {
    setTimeout(() => setShowAnswers(true), 200); // leicht verzögert anzeigen
  }, [question]);

  const handleClick = (isCorrect) => {
    if (answered) return;

    setAnswered(true);
    setFeedback(isCorrect ? "✅ Richtig!" : "❌ Falsch");

    setTimeout(() => {
      setTransitioning(true); // Start: rausfaden
    }, 1200);

    setTimeout(() => {
      onAnswer(isCorrect);   // Callback an Parent
      setAnswered(false);    // Reset
      setFeedback("");
      setShowAnswers(false); // nächste Frage → wieder animiert einblenden
      setTransitioning(false);
    }, 1800);
  };

  const colors = ['#dc3545', '#0d6efd', '#ffc107', '#198754'];
  const icons = ['▲', '◆', '●', '■'];

  return (
    <div className={`container text-center py-5 fade-wrapper ${transitioning ? 'fade-out' : 'fade-in'}`}>
      <h2 className="mb-4 fw-bold text-white">{question.text}</h2>

      <div className="row g-3">
        {question.answers.map((a, i) => (
          <div
            key={i}
            className={`col-12 col-md-6 answer-item ${showAnswers ? 'slide-in' : 'hidden'}`}
            style={{ transitionDelay: `${i * 150}ms` }}
          >
            <button
  className="answer-box w-100 d-flex align-items-center justify-content-center text-white fw-bold"
  style={{
    backgroundColor: colors[i % 4],
    color: i === 2 ? '#000' : '#fff'
  }}
  onClick={() => handleClick(a.isCorrect)}
  disabled={answered}
>
  {icons[i % 4]}&nbsp;{a.text}
</button>

          </div>
        ))}
      </div>

      {feedback && (
        <div className="mt-4 fs-4 fw-semibold text-light quiz-feedback fade-in">{feedback}</div>
      )}

      
    </div>
  );
}
